import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-superuser-reports-memberaccount',
  templateUrl: './superuser-reports-memberaccount.component.html',
  styleUrls: ['./superuser-reports-memberaccount.component.scss']
})
export class SuperuserReportsMemberaccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
